import { Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { colorPrimary } from "../../Styles/Colors";

const StyledButton = styled(Button)(({ theme, variant }) => ({
  borderRadius: "100px",
  height: "40px",
  gap: "8px",
  fontSize: "16px",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  fontWeight: 500,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    bgColor: "transparent",
  },
  "&:focus": {
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
  },
  ...(variant === "contained" && {
    backgroundColor: colorPrimary,
    color: "#ffffff",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  ...(variant === "outlined" && {
    color: colorPrimary,
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",

      boxShadow: "none",
    },
  }),
  ...(variant === "text" && {
    color: colorPrimary,
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  }),
}));

const ButtonComp = ({
  onClick,
  textStyle,
  icon,
  variant = "contained",
  label,
  style = {},
  children,
  ...props
}) => {

 
 
  return (
    <StyledButton
      onClick={onClick}
      variant={variant}
      sx={{
        ...style, 
        alignItems: "center",
      }}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default ButtonComp;
